const clickTab = (selector) => {
    const tabElement = document.querySelector(selector)

    if (tabElement && !tabElement.classList.contains('react-tabs__tab--selected')) {
        tabElement.click()
    }
}

const clickTabAndMoveNext = (tourManager, tabSelector) => () => {
    clickTab(tabSelector)
    setTimeout(() => tourManager.moveNext(), 150)
}

const bindMinimizeOnClick = (element, handler) => {
    if (!element || element._hdvTourMinimizeClick) return

    element.addEventListener('click', handler)
    element._hdvTourMinimizeClick = handler
}

const unbindMinimizeOnClick = (element) => {
    if (!element?._hdvTourMinimizeClick) return

    element.removeEventListener('click', element._hdvTourMinimizeClick)
    delete element._hdvTourMinimizeClick
}

const ensureDetalhesTab = () => {
    clickTab('[data-tour="tab-cliente-detalhes"]')
    return Promise.resolve()
}

const buildEditarClienteTourSteps = (tourManager) => [
    {
        ensureReady: ensureDetalhesTab,
        onHighlighted: () => ensureDetalhesTab(),
        popover: {
            title: 'Cliente cadastrado',
            description: 'Este cliente já foi salvo. Agora as abas Endereços, Contatos e Acesso à Módulos estão disponíveis.',
        },
    },
    {
        element: '[data-tour="tab-cliente-detalhes"]',
        ensureReady: ensureDetalhesTab,
        popover: {
            title: 'Aba Detalhes',
            description: 'Aqui ficam os dados principais do cliente. Você pode alterar nome, perfil e status quando precisar e salvar novamente.',
            side: 'bottom',
            align: 'start',
            onNextClick: () => {
                clickTab('[data-tour="tab-cliente-detalhes"]')
                setTimeout(() => tourManager.moveNext(), 150)
            },
        },
    },
    {
        element: '[data-tour="cliente-perfil"]',
        ensureReady: ensureDetalhesTab,
        popover: {
            title: 'Perfil',
            description: 'Trocar o perfil muda as permissões do cliente no sistema e no aplicativo.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="tab-cliente-enderecos"]',
        popover: {
            title: 'Aba Endereços',
            description: 'Cadastre os endereços deste cliente. Clique em <strong>Próximo</strong> para abrir a aba.',
            side: 'bottom',
            align: 'start',
            onNextClick: clickTabAndMoveNext(tourManager, '[data-tour="tab-cliente-enderecos"]'),
        },
    },
    {
        element: '[data-tour="cliente-enderecos-novo"]',
        popover: {
            title: 'Novo endereço',
            description: 'Use este botão para adicionar um endereço. Ao clicar, o guia será minimizado para você preencher o formulário.',
            side: 'left',
            align: 'start',
            onPrevClick: () => {
                clickTab('[data-tour="tab-cliente-enderecos"]')
                setTimeout(() => tourManager.movePrevious(), 150)
            },
        },
        onHighlighted: (element) => {
            bindMinimizeOnClick(element, () => tourManager.minimize())
        },
        onDeselected: (element) => {
            unbindMinimizeOnClick(element)
        },
    },
    {
        element: '[data-tour="tab-cliente-contatos"]',
        popover: {
            title: 'Aba Contatos',
            description: 'Cadastre telefones e e-mails de referência. Clique em <strong>Próximo</strong> para abrir a aba.',
            side: 'bottom',
            align: 'start',
            onNextClick: clickTabAndMoveNext(tourManager, '[data-tour="tab-cliente-contatos"]'),
        },
    },
    {
        element: '[data-tour="cliente-contatos-novo"]',
        popover: {
            title: 'Novo contato',
            description: 'Use este botão para incluir um contato. Ao clicar, o guia será minimizado para você preencher o formulário.',
            side: 'left',
            align: 'start',
            onPrevClick: () => {
                clickTab('[data-tour="tab-cliente-contatos"]')
                setTimeout(() => tourManager.movePrevious(), 150)
            },
        },
        onHighlighted: (element) => {
            bindMinimizeOnClick(element, () => tourManager.minimize())
        },
        onDeselected: (element) => {
            unbindMinimizeOnClick(element)
        },
    },
    {
        element: '[data-tour="tab-cliente-modulos"]',
        popover: {
            title: 'Aba Acesso à Módulos',
            description: 'Aqui você vincula os módulos contratados para este cliente. Clique em <strong>Próximo</strong> para abrir a aba.',
            side: 'bottom',
            align: 'start',
            onNextClick: clickTabAndMoveNext(tourManager, '[data-tour="tab-cliente-modulos"]'),
        },
    },
    {
        element: '[data-tour="cliente-modulos-novo"]',
        popover: {
            title: 'Novo acesso',
            description: 'Escolha o tipo de acesso disponível na sua conta. Ao clicar, o tour será minimizado para você concluir a vinculação.',
            side: 'left',
            align: 'start',
            onPrevClick: () => {
                clickTab('[data-tour="tab-cliente-modulos"]')
                setTimeout(() => tourManager.movePrevious(), 150)
            },
        },
        onHighlighted: (element) => {
            bindMinimizeOnClick(element, () => tourManager.minimize())
        },
        onDeselected: (element) => {
            unbindMinimizeOnClick(element)
        },
    },
    {
        popover: {
            title: 'Tudo pronto!',
            description: 'Com o cliente cadastrado, volte à lista e use <strong>Enviar Convite / Criar Senha</strong> para liberar o login dele no sistema e no aplicativo.',
            onPrevClick: () => {
                clickTab('[data-tour="tab-cliente-modulos"]')
                setTimeout(() => tourManager.movePrevious(), 150)
            },
        },
    },
]

export default buildEditarClienteTourSteps
